module.exports = __webpack_public_path__ + "node_modules/icheck/skins/minimal/orange.png?e7333f83";